/* eslint-disable prettier/prettier */
import request from '@/utils/request';

const apiPrefix = '/vesionbook-building-core/api/v1';
// const apiPrefix = '/api/v1';

import axios from 'axios';

const api = {
  getInfo: payload => request.get(`${apiPrefix}/wechat/company/setting/${payload}`),
  visitorApply: payload => request.post(`${apiPrefix}/visitor/h5/apply`, payload),
  sendSMS: payload => request.post(`${apiPrefix}/sms/send`, payload),
  uploadPicture: payload => request.post(`${apiPrefix}/common/image/upload`, payload),
  login: payload => request.post(`${apiPrefix}/visitor/h5/login`, payload),
  register: payload => request.post(`${apiPrefix}/visitor/h5/register`, payload),
  visitorList: payload => request.post(`${apiPrefix}/visitor/h5/list`, payload),
  review: payload => request.post(`${apiPrefix}/visitor/h5/approval`, payload),
  devices: payload => request.post(`${apiPrefix}/visitor/h5/selectDeviceList`, payload),
  codeInfo: payload => request.post(`${apiPrefix}/visitor/h5/getVrcode`, payload),
  visitorUserApply: payload => request.post(`${apiPrefix}/visitor/h5/invite`, payload),
  deleteVisitor: payload => request.post(`${apiPrefix}/visitor/h5/delete`, payload),
  hasQrcode: payload => request.post(`${apiPrefix}/visitor/h5/hasQrcode`, payload),
  authPersonName: payload => request.get(`${apiPrefix}/visitor/h5/telephone/query`, payload),

  getMeetingRoomList: payload => request.get(`${apiPrefix}/conference/book/ListAllMeetingRoom`, payload),
  getMeetingRoomByTime: payload => request.get(`${apiPrefix}/conference/book/selectMeetingRoom`, payload),
  getMeetingRoomInfo: payload => request.get(`${apiPrefix}/conference/book/queryMeetingRoom/${payload.id}`, payload),
  getMeetingRoomMyList: payload => request.get(`${apiPrefix}/conference/my/query`, payload),
  getMeetingRoomMyBook: payload => request.get(`${apiPrefix}/conference/my/listMyBook/${payload.id}`, payload),
  getMeetingRoomInfoMy: payload => request.get(`${apiPrefix}/conference/my/detail`, payload),
  getMeetingRoomInfoInvite: payload => request.get(`${apiPrefix}/conference/my/listInvited`, payload),
  getMeetingRoomInfoCheck: payload => request.get(`${apiPrefix}/conference/my/queryCheckRecord/${payload.id}`, payload),
  deleteMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/delete/${payload.id}`, payload),
  addMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/create`, payload),
  updateMeetingRoomInfo: payload => request.post(`${apiPrefix}/conference/book/update/${payload.id}`, payload),
  getMeetingPersonList: payload => request.get(`${apiPrefix}/conference/book/selectPerson`, payload),
  getMeetingAllList: payload => request.get(`${apiPrefix}/conference/book/listAllConference`, payload),
  getTokenByTicketServices:payload =>request.post(`${apiPrefix}/conference/book/login`, payload),

  verifyUser: payload => request.post(`${apiPrefix}/faceCollect/login`, payload),
  collectPhoto: payload => request.post(`${apiPrefix}/faceCollect`, payload),
  getPublicResource: payload => axios.get(`${window.location.origin}/${payload}`),

  getVisitorArea: payload => request.get(`${apiPrefix}/conference/book/sh/h5/select/area`,payload),
  getVisitorAreaList: payload => request.post(`${apiPrefix}/visitor/h5/group/list`,payload),

  // 获取通行二维码
  getQrcode: payload => request.get(`${apiPrefix}/person/h5/getPersonQrcode`, payload),

  getOpenId: payload => request.get(`${apiPrefix}/visitor/h5/jstoken`, payload),

};

export default api;
